import { NavLink } from 'react-router-dom';

/**
 * Abas dos modos de conversa do projeto. No menu lateral existe só um item
 * ("Conversar com a IA" → NEO/Hermes); os outros modos são acessados por estas
 * abas dentro da página. Usada nas três telas (NeoChat, Chat, Conversations).
 */
export function ChatTabs({ slug }: { slug: string }) {
  const tabs = [
    { to: `/p/${slug}/neo`, label: 'Conversar com a IA' },
    { to: `/p/${slug}/chat`, label: 'Chat com agentes' },
    { to: `/p/${slug}/conversations`, label: 'Conversas' },
  ];
  return (
    <div style={{ display: 'flex', gap: 'var(--space-1)', marginBottom: 'var(--space-4)', borderBottom: '1px solid var(--color-border)' }}>
      {tabs.map((t) => (
        <NavLink
          key={t.to}
          to={t.to}
          style={({ isActive }) => ({
            padding: 'var(--space-2) var(--space-3)',
            fontSize: 'var(--font-size-sm)',
            textDecoration: 'none',
            color: isActive ? 'var(--color-fg)' : 'var(--color-fg-muted)',
            borderBottom: isActive ? '2px solid var(--color-accent)' : '2px solid transparent',
            fontWeight: isActive ? 600 : 400,
            marginBottom: -1,
          })}
        >
          {t.label}
        </NavLink>
      ))}
    </div>
  );
}
